<template>
  <div
    class="container-list"
    v-loading="uploadLoading"
    element-loading-text="文件导入中请稍等..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(255, 255, 255, 0.5)"
  >
    <div class="flex">
      <unitList v-show="!($store.state.user.userInfo.natureId == 2)" @select="getUnit" @getFirst="getOne"></unitList>
      <div class="flex1">
        <div class="common-page common-head">
          <!-- <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        信息列表
      </div> -->
          <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
        </div>
        <div class="common-page common-body">
          <div class="common-page common-tool-bar">
            <div class="btn " key="" v-hasPermi="['basic:crtpoint:query']" @click="showDia = true"><i class="icon-tr-search"></i>查询</div>
            <div class="btn ml10" @click="resetSearch">
              重置
            </div>
            <el-button type="info" size="small" class="ml10" plain @click="downmuban()" v-hasPermi="['basic:crtpoint:download']">下载模板</el-button>

            <el-upload
              ref="upload"
              v-hasPermi="['basic:crtpoint:import']"
              class="ml10"
              :action="config.apiUrl + '/crtarea/importcrt'"
              :headers="{ token: $store.state.token }"
              :show-file-list="false"
              :on-progress="handleFileUploadProgress"
              :on-success="handlesuccess"
              :auto-upload="true"
            >
              <el-button size="small" type="success">导入文件</el-button>
            </el-upload>
            <router-link v-hasPermi="['basic:crtpoint:add']" class="btn ml20" to="/qvyu/qvyu-add"> <i class="icon-tr-newly-added"></i>新增 </router-link>
          </div>
          <div class="common-page common-list">
            <el-table :data="list">
              <el-table-column prop="area_name" label="区域名称" align="center"></el-table-column>

              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <router-link v-hasPermi="['basic:crtpoint:edit']" :to="{ path: '/qvyu/qvyu-add', query: { id: scope.row.area_uuid } }">
                    <el-button size="mini" type="warning">编辑</el-button>
                  </router-link>
                  <el-popconfirm
                    key=""
                    v-hasPermi="['basic:crtpoint:remove']"
                    title="确定禁用此记录吗？"
                    class="cursor"
                    @confirm="changeStatus(scope.row.area_uuid, 0)"
                    @onConfirm="changeStatus(scope.row.area_uuid, 0)"
                  >
                    <a slot="reference" class="red">
                      <el-button type="danger" size="mini">删除</el-button>
                    </a>
                  </el-popconfirm>
                </template>
              </el-table-column>
              <el-table-column label="关联地址" align="center">
                <template slot-scope="scope">
                  <router-link
                    v-hasPermi="['basic:crtpoint:address']"
                    :to="{ name: '/qvyu/qvyu-place', path: '/qvyu/qvyu-place', query: { id: scope.row.area_uuid, c_num: cpNum } }"
                    tag="span"
                  >
                    <el-button class="el-icon-paperclip" style="font-size:20px" size="mini"></el-button>
                  </router-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination background layout="prev, pager, next" @current-change="pageChange" :page-size="10" :total="count"></el-pagination>
        </div>
        <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
          <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"></fm-generate-form>
          <div class="center">
            <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
            <el-button @click="showDia = false" size="small">取消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import unitList from '@/components/unitList';
import config from '../../utils/config';

export default {
  components: {
    unitList,
  },
  data() {
    return {
      cpNum: '',
      showDia: false,
      searchForm: this.$getForm('qvyusearch'),
      remoteFuncs: {},
      config: config,
      params: { c_company_num: '', area_name: '', page: 1 },
      list: [],
      count: 0,
      editData: {},
      upload: {
        // 是否显示弹出层（用户导入）
        open: false,
        // 弹出层标题（用户导入）
        title: '',
        // 是否禁用上传
        isUploading: false,
      },
      uploadLoading: false,
    };
  },
  created() {},
  mounted() {},
  watch: {
    cpNum() {
      this.params.c_company_num = this.cpNum;
      this.getList();
    },
  },
  methods: {
    downmuban() {
      var url = `${config.apiUrl}/crtarea/crttemplate?c_company_num=${this.cpNum}`;
      window.open(url, '_blank');
    },
    handleFileUploadProgress(res, status) {
      console.log('set file status', status);
      this.uploadLoading = true;
    },
    handlesuccess(res) {
      if (res.code == 200) {
        this.uploadLoading = false;
        this.getList();
        return this.$message.success('导入成功');
      } else {
        this.$message.error(res.msg);
        if (res.code == 500) {
          this.uploadLoading = false;
        }
        return;
      }
    },

    getList() {
      this.$post('/crt/arealist', this.params).then((res) => {
        this.list = res.data;
        this.count = res.count;
      });
    },
    changeStatus(uuid) {
      this.$post(`/crt/areadel/${uuid}`)
        .then((res) => {
          // this.$message.success('删除成功');
          this.$message({
									message: '删除成功',
									type: 'success',
									duration: 700,
								});
          this.getList();
        })
        .catch((e) => {});
    },
    getOne(v) {
      this.cpNum = v;
    },
    getUnit(v) {
      this.cpNum = v;
    },
    resetSearch() {},
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };

          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss">
.f-list {
  flex-wrap: wrap;

  li {
    width: 240px;
    height: 280px;
    margin-right: 40px;
    margin-bottom: 40px;
  }
}

.com-warp {
  margin-top: 10px;

  li {
    font-size: 18px;
    line-height: 34px;
    color: #333;

    padding-left: 10px;
    opacity: 0.7;

    &:nth-child(odd) {
      background: #efeeff;
    }
  }
}

.tab-wrap {
  padding-bottom: 20px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}

.f-left {
  width: 260px;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  height: 600px;
  margin-right: 30px;
}
</style>
